import React, { useState } from 'react';
import {
    TableRow,
    TableCell,
    Typography,
    Collapse,
    Card
} from '@mui/material';
import VendorChildTable from './vendorChildTable';
import ActionButtons from '../../dashboard/actionButtons';
import EditTextField from '../../../overrides/editField';
import { updateVendorWatcher, deleteVendorWatcher } from '../../../../redux/actionCreators/admin/vendorManagement';
import { useDispatch } from 'react-redux'

const VendorTableRow = ({ rowData }) => {
    const dispatch = useDispatch();

    const [expandOpen, setExpandOpen] = useState(false);
    const [status, setStatus] = useState('list');
    const [editData, setEditData] = useState({});
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

    const [formErrors, setFormErrors] = useState({
        GATEWAY_ID: null,
        PAYMENT_KEY: null,
        PAYMENT_SECRET: null,
    });

    const handleEditChange = (e) => {
        const { name, value } = e.target
        setEditData({ ...editData, [name]: value })
        setFormErrors(prev => ({ ...prev, [name]: null }))
    }

    const clearFormError = (field) => {
        setFormErrors(prev => ({ ...prev, [field]: null }))
    }

    const validatePaymentFields = () => {
        const errors = {}

        if (editData.GATEWAY_ALLOWED) {
            if (!editData.GATEWAY_ID) errors.GATEWAY_ID = 'Payment Gateway is required'
            if (!editData.PAYMENT_KEY) errors.PAYMENT_KEY = 'Payment Key is required'
            if (!editData.PAYMENT_SECRET) errors.PAYMENT_SECRET = 'Payment Secret is required'
        }

        setFormErrors(prev => ({ ...prev, ...errors }))
        return !Object.keys(errors).length
    }

    const handleEdit = () => {
        let data = {
            ...rowData,
            GATEWAY_ALLOWED: Number(rowData.gateway_allowed) === 1,
            GATEWAY_ID: rowData.gateway_id,
            PAYMENT_KEY: rowData.payment_key,
            PAYMENT_SECRET: rowData.payment_secret,
        }
        setEditData(data);
        setStatus('edit');
        setExpandOpen(true);
    }

    const handleDelete = async () => {
        let data = { "ACTION": "DELETE" }
        await dispatch(deleteVendorWatcher(rowData.NID, { data }))
        setStatus('list');
        setDeleteDialogOpen(false);
    }

    const tickIconFunction = async () => {
        if (!validatePaymentFields()) return;

        let data = { ...editData }
        data.ACTION = "UPDATE"
        data.GATEWAY_ALLOWED = editData.GATEWAY_ALLOWED ? 1 : 0
        if (!editData.GATEWAY_ALLOWED) {
            data.GATEWAY_ID = null
            data.PAYMENT_KEY = null
            data.PAYMENT_SECRET = null
        }
        // data.cMenuName = JSON.stringify(editData.cMenuName)
        // Stays in edit mode if the save fails, so nothing typed is lost
        dispatch(updateVendorWatcher(rowData.NID, data, () => setStatus('list')));
    }

    const cancelIconFunction = () => {
        setEditData({});
        setFormErrors({ GATEWAY_ID: null, PAYMENT_KEY: null, PAYMENT_SECRET: null });
        setStatus('list');
    }

    return (
        <>
            <TableRow
                hover
                tabIndex={-1}
            >
                {status === 'list' ?
                    <>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.NID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CVENDORID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CVENDORNAME}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CVENDORDESC}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CVENDORADDRESS}
                            </Typography>
                        </TableCell>
                    </>
                    :
                    <>
                        <TableCell align="left" sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant='t14_600'>
                                {rowData.NID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CVENDORID'
                                value={editData.CVENDORID}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CVENDORNAME'
                                value={editData.CVENDORNAME}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CVENDORDESC'
                                value={editData.CVENDORDESC}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CVENDORADDRESS'
                                value={editData.CVENDORADDRESS}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                    </>
                }
                <TableCell align="right">
                    <ActionButtons status={status} setStatus={setStatus} expandOpen={expandOpen} setExpandOpen={setExpandOpen} type={'vendor'} tickIconFunction={tickIconFunction} handleDelete={handleDelete} handleEdit={handleEdit} cancelIconFunction={cancelIconFunction} setDeleteDialogOpen={setDeleteDialogOpen} deleteDialogOpen={deleteDialogOpen} />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={6} style={{ padding: 0 }}>
                    <Collapse in={expandOpen} timeout="auto" unmountOnExit>
                        <Card sx={{ bgcolor: 'grey.200' }} >
                            <VendorChildTable expandOpen={expandOpen} rowData={rowData} handleEditChange={handleEditChange} status={status} editData={editData} setEditData={setEditData} formErrors={formErrors} clearFormError={clearFormError} />
                        </Card>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )

}

export default VendorTableRow